"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _ConfirmationDialog = _interopRequireDefault(require("react-platform-components/dist/ConfirmationDialog"));

var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));

var _reactRedux = require("react-redux");

var _config = require("../config");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ReviewOfProductComponent = function ReviewOfProductComponent(props) {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      tablePage = _useState2[0],
      setTablePage = _useState2[1];

  var _useState3 = (0, _react.useState)(10),
      _useState4 = _slicedToArray(_useState3, 2),
      tablePerPage = _useState4[0],
      setTablePerPage = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedComment = _useState6[0],
      setSelectedComment = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      confirmDialogOpen = _useState8[0],
      setConfirmDialogOpen = _useState8[1];

  var allowDelete = props.allowDelete;

  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
    var productReviewsReducer = _ref.productReviewsReducer,
        auth = _ref.auth;
    return {
      totalReviews: productReviewsReducer.totalReviews,
      reviews: productReviewsReducer.reviews,
      user: auth.user
    };
  }),
      reviews = _useSelector.reviews,
      totalReviews = _useSelector.totalReviews,
      user = _useSelector.user;

  (0, _react.useEffect)(function () {
    fetchComments(tablePage, tablePerPage);
  }, []);

  var handlerPageChanged = function handlerPageChanged(event, page) {
    setTablePage(page);
    fetchComments(page, tablePerPage);
  };

  var handlerPerPageChanged = function handlerPerPageChanged(event) {
    var perPage = event.target.value;
    setTablePerPage(perPage);
    fetchComments(tablePage, perPage);
  };

  var fetchComments = function fetchComments(page, perPage, params) {
    var endpoint = allowDelete ? 'products-reviews' : 'public-products-reviews';
    dispatch({
      params: _objectSpread(_objectSpread({}, params), {}, {
        _page: page + 1,
        _per_page: perPage,
        _sort: '-created_at'
      }),
      type: 'FETCH_PRODUCTS_REVIEWS',
      endpoint: endpoint
    });
  };

  var handleDialog = function handleDialog(comment) {
    if (confirmDialogOpen) {
      setConfirmDialogOpen(false);
      setSelectedComment(null);
    } else {
      setConfirmDialogOpen(true);
      setSelectedComment(comment);
    }
  };

  var deleteComment = function deleteComment() {
    dispatch({
      type: 'DELETE_PRODUCTS_REVIEW',
      id: selectedComment.id,
      page: tablePage,
      perPage: tablePerPage
    });
    handleDialog();
  };

  var fillRating = function fillRating(value, filledElement, emptyElement, halfFilledElement) {
    var elements = [];
    var numberOfElement = 5;
    var isInt = value % 1 === 0;

    for (var i = 0; i < numberOfElement; i++) {
      if (i < (value | 0)) {
        elements.push(filledElement);
      } else {
        if (!isInt && value % 1 > 0.4 && i < value) {
          elements.push(halfFilledElement);
        } else {
          elements.push(emptyElement);
        }
      }
    }

    return elements;
  };

  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 3,
    style: {
      boxShadow: '4px 3px 20px #c7c7c7'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Table, {
    "aria-labelledby": "tableTitle"
  }, /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Date",
    defaultMessage: "Date"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "User",
    defaultMessage: "User"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Note",
    defaultMessage: "Note"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Message",
    defaultMessage: "Message"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Product",
    defaultMessage: "Product"
  })), allowDelete && /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    size: "small",
    align: "right"
  }))), /*#__PURE__*/_react.default.createElement(_core.TableBody, null, reviews.length > 0 ? reviews.map(function (comment, index) {
    return /*#__PURE__*/_react.default.createElement(_core.TableRow, {
      key: index,
      hover: true,
      tabIndex: -1
    }, /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "overline"
    }, (0, _moment.default)(comment.created_at).format("DD MMM YYYY"))), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, comment.user.name), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      container: true,
      alignItems: "center",
      alignContent: "center",
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      style: {
        marginRight: '.25rem'
      }
    }, " ", "(".concat(comment.note, ") "), " ")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      className: "flex",
      item: true,
      alignItems: "center",
      alignContent: "center"
    }, fillRating(comment.note, /*#__PURE__*/_react.default.createElement(_core.Icon, {
      color: "primary",
      style: {
        fontSize: '1.2rem'
      }
    }, "star"), /*#__PURE__*/_react.default.createElement(_core.Icon, {
      color: "primary",
      style: {
        color: '#a5a5a5',
        fontSize: '1.2rem'
      }
    }, "star_border"), /*#__PURE__*/_react.default.createElement(_core.Icon, {
      color: "primary",
      style: {
        fontSize: '1.2rem'
      }
    }, "star_half"))))), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, comment.comment), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement("a", {
      href: "".concat(_config.BASE_URL).concat(_config.PRODUCTS_ENDPOINT, "/").concat(comment.product.id),
      target: "_blank",
      rel: "noopener noreferrer"
    }, comment.product && comment.product.name ? comment.product.name : /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Product",
      defaultMessage: "Product"
    }))), allowDelete && /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      size: "small",
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      style: {
        marginRight: '1rem'
      },
      onClick: function onClick() {
        return handleDialog(comment);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "delete"))));
  }) : /*#__PURE__*/_react.default.createElement(_core.TableRow, null, /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    align: "center",
    colSpan: 4
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    alignItems: "center",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "mr-4"
  }, "info")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "no results...",
    defaultMessage: "no results..."
  })))))))), /*#__PURE__*/_react.default.createElement(_core.TablePagination, {
    component: "div",
    count: totalReviews,
    rowsPerPage: tablePerPage,
    page: tablePage,
    backIconButtonProps: {
      'aria-label': 'Previous Page'
    },
    nextIconButtonProps: {
      'aria-label': 'Next Page'
    },
    rowsPerPageOptions: [10, 25, 50],
    onChangePage: handlerPageChanged,
    onChangeRowsPerPage: handlerPerPageChanged
  }), /*#__PURE__*/_react.default.createElement(_ConfirmationDialog.default, {
    closeLabel: "Cancel",
    confirmLabel: "Confirm",
    title: "Are you sure you want to delete this item?",
    open: confirmDialogOpen,
    close: function close() {
      return handleDialog();
    },
    confirmAction: deleteComment
  }));
};

var _default = ReviewOfProductComponent;
exports.default = _default;